import { RouteRecordRaw } from "vue-router";

const Additions: RouteRecordRaw = {
  path: "additions",
  component: () => import("@/views/public/index.vue"),
  meta: {
    title: "additions",
  },
  children: [
    {
      path: "",
      name: "addition",
      component: () => import("@/views/public/additions/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "additions",

      },
    },
    {
      path: "index",
      name: "addition index",
      component: () => import("@/views/public/additions/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "additions",
      },
    },
    {
      path: "add",
      name: "Add New addition",
      component: () => import("@/views/public/additions/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "add",
        title: "AddNew",
      },
    },
    {
      path: "Edit/:Id",
      props: true,
      name: "Edit addition",
      component: () => import("@/views/public/additions/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "edit",
        title: "Edit",
      },
    },
  ],
};

export default Additions;
